<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre2" id="calibre_pb_0">ON THE ROAD<br class="calibre3"/>WITH WELLINGTON</h1>
<p class="paranoindent"> </p>
<p class="paranoindent"> </p>
<p class="paranoindent"> </p>
<div class="image-wrap">
<div class="image">
<img alt="image" class="calibre1" src="images/00002.jpeg"/>
</div>
</div>
<p class="paranoindent"> </p>
<p class="paranoindent"> </p>
<p class="paracenter1"><b class="calibre4">NAPOLEONIC LIBRARY</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0001.vue?1f2f205b